"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 */
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
exports.default = getFreshSideObject;
//# sourceMappingURL=getFreshSideObject.js.map